export default __webpack_public_path__ + "static/media/oscar.874c0059.otf";